import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    background: "#FFF",
    minHeight: "100vh",
    flex: 1,
    padding: "8px 16px 0px 16px",
    maxWidth: "99vw",
    overflowX: "hidden",
    overflowY: "auto",
  },
  text: {
    color: "#00326d",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
  },
  strong: {
    fontWeight: "bold",
  },
  image: {
    maxWidth: "200px",
    height: "5vh",
  },
  title: {
    fontWeight: "bold",
    fontSize: "24px",
    margin: "16px 0px",
  },
  tag: {
    marginLeft: "20px",
  },
  flagContainer: {
    marginRight: "8px",
    cursor: "pointer",
  },
}));

export default styles;
